var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"vs-component vs-button",class:[`vs-button-${_vm.isColor() ? _vm.color : null}`,`vs-button-${_vm.type}`,{
    'isActive':_vm.isActive,
    'includeIcon':_vm.icon,
    'includeIconOnly':_vm.icon && !_vm.$slots.default,
    'vs-radius':_vm.radius
  }, _vm.size],style:([_vm.styles,{
    'width':/[px]/.test(_vm.size) ? `${_vm.size}` : null,
    'height':/[px]/.test(_vm.size) ? `${_vm.size}` : null
  }]),attrs:{"type":_vm.button,"name":"button"}},'button',_vm.$attrs,false),_vm.listeners),[(!_vm.is('line')&&!_vm.is('gradient')&&!_vm.is('relief'))?_c('span',{ref:"backgroundx",staticClass:"vs-button-backgroundx vs-button--background",style:(_vm.stylesBackGround)}):_vm._e(),(_vm.icon)?_c('vs-icon',{staticClass:"vs-button--icon",style:({
      'order':_vm.iconAfter ? 2 : 0,
      ['margin-' + _vm.isRTL('left')]: _vm.$slots.default && !_vm.iconAfter ? '5px' : '0px',
      ['margin-' + _vm.isRTL('right')]: _vm.$slots.default && _vm.iconAfter ? '5px' : '0px'
    }),attrs:{"icon":_vm.icon,"icon-pack":_vm.iconPack}}):_vm._e(),(_vm.$slots.default)?_c('span',{staticClass:"vs-button-text vs-button--text"},[_vm._t("default")],2):_vm._e(),_c('span',{ref:"linex",staticClass:"vs-button-linex",style:(_vm.styleLine)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }